import { HomePagePad } from '@/common/styles/shared.styles';
import HomePersonGridList from './components/HomePersonGridList';
import HomePersonGridLoadMore from './components/HomePersonGridLoadMore';
import HomePersonGridSkeleton from './components/HomePersonGridSkeleton';

const HomePersonGrid = ({
	persons,
	onSelectProfile,
	onReload,
	hasMore,
	onLoadMore,
	isLoadingMore,
	isLoading,
}) => {
	const showSkeleton = isLoading && persons.length === 0;

	return (
		<HomePagePad>
			{showSkeleton ? (
				<HomePersonGridSkeleton />
			) : (
				<HomePersonGridList
					persons={persons}
					onSelectProfile={onSelectProfile}
					onReload={onReload}
				/>
			)}
			<HomePersonGridLoadMore
				hasMore={hasMore}
				isLoadingMore={isLoadingMore}
				onLoadMore={onLoadMore}
			/>
		</HomePagePad>
	);
};

export default HomePersonGrid;
